<template>
  <div
    v-if="countTags"
    class="tender-tags">
    <div
      class="tender-tags_items"
      :class="{'is-collapse': collapse}">
      <sChip
        v-for="(tagItem, tagIndex) in tags"
        :key="`tag-${tagItem.key}-${tagIndex}`"
        :background="tagItem.background ? tagItem.background : 'var(--v-secondary__green_chosen-base)'"
        class="tender-tags_item"
        :class="{'pointer': tagItem.key}"
        :color="tagItem.color ? tagItem.color : 'var(--text-color)'">
        <div
          @click="tagItem.key==='clearAll' ? deleteTag(tagItem) : null">
          {{ tagItem.label }}
        </div>
        <div
          class="ml-2 pointer"
          @click="deleteTag(tagItem)">
          <sIcon
            :color="tagItem.color ? tagItem.color : 'var(--text-color)'"
            :data-qa="`tag-${tagItem.key}-${tagIndex}-close`"
            size="10"
            type="cross"/>
        </div>
      </sChip>
    </div>
    <div
      class="tender-tags_collapse-block">
      <span
        class="tender-tags_collapse-block_btn"
        @click="collapse = !collapse">
        <sIcon
          :rotate="collapse ? 0 : -180"
          size="12"
          type="arrow"/>
      </span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TenderTags',
  data() {
    return {
      collapse: false
    }
  },
  methods: {
    deleteTagItem(filters, item) {
      if (item.type === 'Array') {
        let indexOnSpr = filters?.[item.key].indexOf(item.id)
        if (indexOnSpr !== -1) {
          filters?.[item.key].splice(indexOnSpr, 1)
        }
        if (!filters?.[item.key].length) {
          delete filters?.[item.key]
        }
      } else if (item.type === 'Date') {
        delete filters?.[item.key]
      }
    },
    deleteTag(item) {
      const filtersObject = item.contain ? 'containsFilter' : 'notContainFilter'
      const result = this.$_.cloneDeep(this.filters)
      switch (item.key) {
      case 'clearAll':
        result.tenderSearchParam.phrase = null
        result.tenderSearchParam[filtersObject] = null
        break
      case 'find':
        result.tenderSearchParam.phrase = null
        break
      default:
        this.deleteTagItem(result.tenderSearchParam[filtersObject], item)
        break
      }
      this.$root.$emit('setActiveTemplateFilters', null)
      this.$emit('update:filters', result)
    },
  },
  computed: {
    ...mapGetters({
      statuses: 'getTenderStatuses',
    }),
    countTags() {
      if (!this.tags?.length) {
        return 0
      }
      return this.tags.length < 2 ? this.tags.length : this.tags.length - 1
    },
    tags() {
      const tagFromSpr = (ids, spr, keyField, valueField, label, tagKey) => {
        const newTags = ids.map(id => ({
          id: id,
          key: tagKey,
          type: 'Array',
          label: spr?.find(br => br[keyField] === id)?.[valueField] || label + ' ' + id
        }))
        return this.$_.cloneDeep(newTags)
      }

      const tagFromDate = (values, tagKey, label) => {
        const dateToStr = (date) => {
          return this.$d(new Date(date))
        }
        const getLabel = (values) => {
          let result = ''
          if (!values.to && !values.from) {
            result += ' ' + this.$t('Purchasing.AllTheTime')
          } else if (!values.to) {
            result += this.$t('Common.DateFrom').toLowerCase()
            result += ` ${dateToStr(values.from)}`
          } else if (!values.from) {
            result += this.$t('Common.DateTill').toLowerCase()
            result += ` ${dateToStr(values.to)}`
          } else {
            result = values.from == values.to ? dateToStr(values.from) : `${dateToStr(values.from)} - ${dateToStr(values.to)}`
          }
          return result
        }
        return {
          key: tagKey,
          type: 'Date',
          from: !!values.from,
          to: !!values.to,
          label: `${label}: ${getLabel(values)}`
        }
      }

      const getTags = (filters, contain) => {
        if (!filters || !Object.keys(filters)?.length) {
          return []
        }

        let result = []
        if (filters?.categoryIds?.length) {
          result = result.concat(
            filters?.categoryIds.map(i => ({
              key: 'categoryIds',
              type: 'Array',
              id: i,
              label: i
            }))
          )
        }
        if (filters?.biddingTypeCodes?.length) {
          result = result.concat(tagFromSpr(
            filters.biddingTypeCodes,
            this.spr.biddingTypes,
            'biddingTypeId',
            'titleRu',
            this.$t('Tenders.biddingTypes'),
            'biddingTypeCodes'
          ))
        }
        if (filters?.contactIds?.length) {
          result = result.concat(tagFromSpr(
            filters.contactIds,
            this.spr.contactPeople,
            'contactId',
            'name',
            this.$t('Tenders.Manager'),
            'contactIds'
          ))
        }
        if (filters?.departmentIds?.length) {
          result = result.concat(tagFromSpr(
            filters.departmentIds,
            this.spr.departments,
            'id',
            'title',
            this.$t('Common.Department'),
            'departmentIds'
          ))
        }
        if (filters?.organizationIds?.length) {
          result = result.concat(tagFromSpr(
            filters.organizationIds,
            this.spr.organizations,
            'organizationItId',
            'title',
            this.$t('Common.Organization'),
            'organizationIds'
          ))
        }
        if (filters?.tenderStatuses?.length) {
          result = result.concat(tagFromSpr(
            filters.tenderStatuses,
            this.statuses,
            'statusCode',
            'title',
            this.$t('Purchasing.Status'),
            'tenderStatuses'
          ))
        }
        if (filters?.tariffUserIds) {
          result = result.concat(tagFromSpr(
            filters.tariffUserIds,
            this.spr.personalManagers,
            'userId',
            'name',
            this.$t('Tenders.managerFO'),
            'tariffUserIds'
          ))
        }
        if (filters?.dateAdded) {
          result = result.concat(tagFromDate(
            filters.dateAdded,
            'dateAdded',
            this.$t('Tenders.DateOfCreation')
          ))
        }
        if (filters?.contractDate) {
          result = result.concat(tagFromDate(
            filters.contractDate,
            'contractDate',
            this.$t('Tenders.ContractDate')
          ))
        }

        if (filters?.publication) {
          result = result.concat(tagFromDate(
            filters.publication,
            'publication',
            this.$t('Tenders.PublicationDate')
          ))
        }
        if (filters?.tenderingEndDate) {
          result = result.concat(tagFromDate(
            filters.tenderingEndDate,
            'tenderingEndDate',
            this.$t('Tenders.DateTo')
          ))
        }
        if (this.filters?.tenderSearchParam?.phrase) {
          result.push({
            key: 'find',
            label: this.filters?.tenderSearchParam?.phrase,
          /*background: 'var(--v-secondary__green_not_active-base)',
          color: 'var(--white-color)'*/
          })
        }
        if (result?.length > 1) {
          result.push({
            key: 'clearAll',
            label: this.$t('Common.Clear'),
            background: 'var(--v-secondary__green_not_active-base)',
            color: 'var(--white-color)'
          })
        }
        result.map(i => i.contain = contain)
        return result || []
      }
      return [
        ...getTags(this.filters?.tenderSearchParam?.containsFilter || {}, true),
        ...getTags(this.filters?.tenderSearchParam?.notContainFilter || {}, false),
      ].flat(1)
    },
  },
  props: {
    filters: {
      type: Object
    },
    spr: {
      type: Object
    },
  },
}
</script>
<style scoped lang="scss">
.tender-tags {
  transition: all 0.25s;
  position: sticky;
  top: -24px;
  z-index: 8;
  background: var(--v-main__green-base);
  &_item {
    height: 20px;
    margin-right: 4px;
  }
  &_items {
    text-align: left;
    transition: all 0.25s;
    max-height: 100%;
    overflow: hidden;
    &.is-collapse {
      border-top: 0px solid transparent;
      max-height: 0;
    }
  }
  &_collapse-block {
    word-wrap: break-word;
    font-size: 12px;
    display: table;
    text-align: center;
    transition: all 0.25s;
    &:before,
    &:after {
      content: "";
      display: table-cell;
      position: relative;
      top: 50%;
      width: 50%;
      -webkit-transform: translateY(50%);
      transform: translateY(50%);
      border-top: 1px solid var(--v-main__light_green-base);
    }
    &_btn {
      cursor: pointer;
      white-space: nowrap;
      padding: 0 10px;
    }
  }
}
</style>
